import React from 'react';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import NoSsr from '@mui/material/NoSsr';
import Grid from '@mui/material/Grid';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const useStyles = makeStyles(() => ({
  textField: {
    width: '100%'
  }
}));

const DateTimeFilter = ({
  id,
  name,
  label,
  helperText,
  placeholder,
  autoFocus = false,
  fullWidth,
  required,
  readOnly,
  disabled,
  clearable,
  disableFuture,
  value = null,
  onChange,
  format = 'YYYY-MM-DD HH:mm:ss',
  // variant = 'dialog',
  inputVariant,
  disableToolbar,
  error
}) => {
  const classes = useStyles();

  return (
    <NoSsr>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Grid container justifyContent="space-around">
          <DateTimePicker
            id={id}
            name={name}
            label={label}
            helperText={helperText}
            placeholder={placeholder}
            fullWidth={fullWidth}
            required={required}
            readOnly={readOnly}
            disabled={disabled}
            clearable={clearable}
            disableFuture={disableFuture}
            value={value ? moment.utc(value) : null}
            onChange={(date) => {
              onChange(date, name);
            }}
            autoFocus={autoFocus}
            // minDate={new Date()}
            ampm={false}
            format={format}
            // variant={variant}
            inputVariant={inputVariant}
            disableToolbar={disableToolbar}
            className={classes.textField}
            error={error}
          />
        </Grid>
      </LocalizationProvider>
    </NoSsr>
  );
};

export default DateTimeFilter;
